import throttle from "./throttle";

var ScrollTween;
{
    var instances = [];
    var currentScrollPos = window.scrollY;
    var previousScrollPos = 0;

    ScrollTween = class {
        constructor(_options) {
            const defaults = {
                element: null,
                from: "top-bottom",
                to: "bottom-top",
                callback: function (_n, _el) {},
                css: false,
                threshold: 1,
                decimalPlaces: 3,
                debug: false,
            };
            const options = Object.assign({}, defaults, _options);

            this.element = options.element;
            this.from = options.from;
            this.to = options.to;
            this.callback = options.callback;
            this.css = options.css;
            this.threshold = options.threshold;
            this.decimalPlaces = options.decimalPlaces;
            this.debug = options.debug;

            this.triggerPointTop;
            this.triggerPointBottom;

            this.withinTriggerPoints;

            this.thresholdExceeded;
            this.animationScheduled = false;
            this.roundingNumber = Math.pow(10, this.decimalPlaces);

            instances.push(this);

            this.init();
        }

        init() {
            var elementOffset = this.getOffset(this.element);
            var elementHeight = this.element.clientHeight;
            var windowHeight = window.innerHeight;

            switch (this.from) {
                case "top-bottom": // Top of element crosses bottom of viewport.
                    this.triggerPointTop = elementOffset - windowHeight;
                    break;
                case "top-middle": // Top of element crosses middle of viewport.
                    this.triggerPointTop = elementOffset - windowHeight / 2;
                    break;
                case "top-top": // Top of element crosses top of viewport.
                    this.triggerPointTop = elementOffset;
                    break;
                default:
                    this.triggerPointTop = $this.from;
            }

            switch (this.to) {
                case "bottom-bottom": // Bottom of element crosses bottom of viewport.
                    this.triggerPointBottom = elementOffset + elementHeight - windowHeight;
                    break;
                case "bottom-middle": // Bottom of element crosses middle of viewport.
                    this.triggerPointBottom = elementOffset + elementHeight - windowHeight / 2;
                    break;
                case "bottom-top": // Bottom of element crosses top of viewport.
                    this.triggerPointBottom = elementOffset + elementHeight;
                    break;
                default:
                    this.triggerPointBottom = $this.to;
            }

            if (this.css) this.element.style.setProperty("--i", " " + this.getProgress());
            this.callback(this.getProgress(), this.element);

            if (this.debug) {
                console.log(this);
                this.drawTriggerPoints();
            }

            return this;
        }

        onScroll() {
            this.thresholdExceeded = Math.abs(previousScrollPos - currentScrollPos) >= this.threshold;
            this.withinTriggerPoints =
                currentScrollPos >= this.triggerPointTop && currentScrollPos <= this.triggerPointBottom;

            if (this.thresholdExceeded && this.withinTriggerPoints && !this.animationScheduled) {
                this.animationScheduled = true;
                window.requestAnimationFrame(this.tweenByScroll.bind(this));
            }
        }

        tweenByScroll() {
            var n = this.getProgress();

            this.callback(n, this.element);
            if (this.css) this.element.style.setProperty("--i", " " + n);
            this.animationScheduled = false;
        }

        getOffset(_element) {
            var rect = _element.getBoundingClientRect();
            var win = _element.ownerDocument.defaultView;

            return rect.top + win.pageYOffset;
        }

        getProgress(_num = currentScrollPos, _from = this.triggerPointTop, _to = this.triggerPointBottom) {
            return Math.round(((_num - _from) / (_to - _from)) * this.roundingNumber) / this.roundingNumber;
        }

        drawTriggerPoints() {
            var array = [this.triggerPointTop, this.triggerPointBottom];
            var el;

            document.querySelectorAll(".scrolltween-debug").forEach(function (_el) {
                _el.remove();
            });

            array.forEach(function (_val) {
                el = document.createElement("div");
                el.classList += "scrolltween-debug";
                el.innerText = `scrolltween-trigger-point: ${_val}px`;
                el.style.cssText = `
                    position: absolute;
                    top: ${_val}px;
                    right: 0;
                    background: yellow;
                `;
                document.body.appendChild(el);
            });
        }

        refresh() {
            this.init();
        }
    };

    ScrollTween.refreshAll = function () {
        currentScrollPos = window.scrollY;
        instances.forEach((_instance) => _instance.refresh());
    };

    window.addEventListener("resize", ScrollTween.refreshAll);

    window.addEventListener("scroll", function () {
        currentScrollPos = window.scrollY;
        instances.forEach((_instance) => _instance.onScroll());
        previousScrollPos = currentScrollPos;
    });

    document.addEventListener("DOMContentLoaded", function () {
        new ResizeObserver(
            throttle(function () {
                ScrollTween.refreshAll();
            }, 100)
        ).observe(document.body);
    });
}

export default ScrollTween;
